import { render, staticRenderFns } from "./AgeGroup.vue?vue&type=template&id=7520a776&"
import script from "./AgeGroup.vue?vue&type=script&lang=js&"
export * from "./AgeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports